/**
 * Campos do registro que o profissional pode remover durante a edicao e
 * incluir de novo. Remover so marca active = false: o conteudo continua salvo
 * e volta junto quando o campo e incluido outra vez.
 */

/**
 * O texto destes tipos aponta para dados de outro modulo (tratamento
 * odontologico, consulta de pre-natal). A API recusa remove-los.
 */
export const NON_REMOVABLE_TYPES = ['odontogram', 'prenatal_panel'];

export function isAttributeActive(attribute) {
  return attribute?.active !== false;
}

export function isAttributeRemovable(attribute) {
  return !NON_REMOVABLE_TYPES.includes(attribute?.type);
}

/**
 * @param {Array} attributes
 * @returns {Array}
 */
export function visibleAttributes(attributes = []) {
  return (attributes ?? []).filter(isAttributeActive);
}

/**
 * @param {Array} attributes
 * @returns {Array}
 */
export function removedAttributes(attributes = []) {
  return (attributes ?? []).filter((attribute) => !isAttributeActive(attribute));
}

/**
 * Campos listados no menu de campos do registro: os removiveis, ativos ou nao.
 *
 * @param {Array} attributes
 * @returns {Array}
 */
export function manageableAttributes(attributes = []) {
  return (attributes ?? []).filter(isAttributeRemovable);
}
